exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img_list_0db8b55{margin-right:20px}.btn_box_1e098d4{text-align:center;.btn_c7f36b8{width:80px}}", ""]);

// exports
exports.locals = {
	"img_list": "img_list_0db8b55",
	"btn_box": "btn_box_1e098d4",
	"btn": "btn_c7f36b8"
};